import React from "react";
import { Environment } from "@store/types";
import { State, getEnvironments } from "@store";
import { useSelector, useDispatch } from "react-redux";

type Data<T> = [T, Error | null, boolean];

export function useEnvironments(
  application_id?: number | undefined
): Data<Environment[] | null> {
  const dispatch = useDispatch();
  const key = application_id === undefined ? "*" : application_id;
  const [environments, error, fetching] = useSelector((state: State) => [
    state.environments[key],
    state.network.error.environments[key],
    state.network.fetching.environments[key],
  ]);

  React.useEffect(() => {
    if (!environments && !fetching && !error) {
      dispatch(getEnvironments(application_id));
    }
  }, [application_id, dispatch, environments, error, fetching]);

  return [environments, error, fetching];
}
